<template>
  <v-alert :color="color" text outlined dark class="body-2 pa-2">
    <p v-if="title" class="mb-0">
      <span class="font-weight-bold">Issue: {{ title }}</span>.
    </p>
    <p v-if="type === 'return'" class="mb-0">
      The provider requires you to fix one or more issues before continuing translation. Please check the job messages below for more details.
    </p>
    <slot />
  </v-alert>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    type: { type: String, default: 'return' }
  },
  computed: {
    color() {
      if (this.type === 'return') {
        return 'red'
      }

      return 'warning'
    }
  }
}
</script>
